<template>
    <div class="page light">

        <Top></Top>

        <div class="hidden-xl hidden-lg navbar navbar-style-1">
            <div class="navbar-inner">
                <a v-on:click="$root.back()" class="link back" v-bind:class="{'hidden': voltar}">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.439312 13.0606L5.75391 18.3752C6.04683 18.6682 6.43069 18.8146 6.81459 18.8146C7.1985 18.8146 7.58236 18.6682 7.87528 18.3752C8.46103 17.7894 8.46103 16.8397 7.87528 16.2539L5.12133 13.5H22.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5H5.12133L7.87528 7.7461C8.46103 7.1603 8.46103 6.21057 7.87528 5.62477C7.28944 5.03898 6.33975 5.03898 5.75391 5.62477L0.439312 10.9394C-0.146437 11.5251 -0.146437 12.4749 0.439312 13.0606Z" fill="black"></path>
                    </svg>
                </a>
                <div class="title" style="">Agenda</div>
                <div class="right">
                    <a  class="link hidden">
                        <i class="las la-shopping-cart"></i>
                    </a>
                </div>
            </div>
        </div>

        <div class="page-content content-area pt-70 bottom-sp60">

            <div class="container hidden-xs hidden-md">
                <h2>Agenda</h2>
            </div>

            <div class="container" style="background: #f7f7f7; padding-bottom: 15px; padding-top: 15px;">
                <h6 class="ma-0">
                    Filtrar por tipo de atendimento
                </h6>

                <div class="row">  
                    <div class="col-100">
                        <p class="segmented segmented-strong">
                            <button class="button" v-on:click="setAgendaTipo('')" v-bind:class="{'button-active button-primary': form.agendaTipo == ''}">
                                Todos
                            </button>
                            <button class="button" v-on:click="setAgendaTipo('presencial')" v-bind:class="{'button-active button-primary': form.agendaTipo == 'presencial'}">
                                Presencial
                            </button>
                            <button class="button" v-on:click="setAgendaTipo('domiciliar')" v-bind:class="{'button-active button-primary': form.agendaTipo == 'domiciliar'}">
                                Domiciliar
                            </button>
                            <button class="button" v-on:click="setAgendaTipo('online')" v-bind:class="{'button-active button-primary': form.agendaTipo == 'online'}">
                                Online
                            </button>
                            <span class="segmented-highlight"></span>
                        </p>
                    </div>                
                </div>

            </div>

            <div v-if="form.agendaTipo == 'presencial'" class="container">
                <h6 style="margin-top: 20px; margin-bottom: 10px">
                    <i class="las la-map-marker"></i>
                    Escolha um local para atendimento
                </h6>
            </div>
            <div v-if="form.agendaTipo == 'presencial'" data-space-between="10" data-slides-per-view="auto" data-centered-slides="false" class="swiper-container swiper-init locais-swiper" style=" padding-right: 15px">
                <div class="swiper-wrapper" style="">

                    <div v-for="(item, index) in agendas.itens" v-if="item.tipo == 'presencial'"  class="swiper-slide" style="width: auto; margin-left: 15px;">
                        <span v-on:click="setAgenda(item)" v-bind:class="{'color-primary': form.agendaCod == item.cod, 'color-grey': form.agendaCod != item.cod, 'badge-outline': form.agendaCod != item.cod}"  class="badge badge-large">{{item.localNome}}</span>
                    </div>    

                </div>
            </div>    

            <div class="container" v-if="form.agendaTipo == 'presencial' && agenda">
                <div class="block-title" style="margin-top: 18px;">
                    <i class="las la-map-marker"></i>
                    Local do atendimento:
                </div>
                <p style="margin-bottom: 0px; padding-left: 30px; margin-top: 0px; font-size: 16px;">
                    <i class="las la-hospital"></i> {{agenda.localNome}}
                </p>
                <small style="display: block; line-height: 130%; font-size: 12px; margin-top: 5px; padding-left: 30px; padding-right: 30px;">
                    {{agenda.localEndereco}}, {{agenda.localNumero != '' ? agenda.localNumero : 's/n'}}. {{agenda.localCep}}. {{agenda.localBairro}}. {{agenda.localCidade}} - {{agenda.localEstado}}
                </small>
            </div>
            
            <div v-if="horarios.loaded && horarios.message">
                <div class="container">
                    <h6 style="margin-top: 20px; margin-bottom: 5px; color: #666; text-align: center;">
                        <i class="las la-times"></i>
                        {{horarios.message}}
                    </h6>
                </div>     
            </div>                     

            <div v-if="horarios.itens.length > 0 && horarios.loaded && !horarios.message">
                <div class="container">
                    <h6 style="margin-top: 20px; margin-bottom: 10px;">
                        <i class="las la-clock"></i>
                        Horários
                        <span class="badge badge-fill badge-small color-green" style="margin-right: 5px; float: right; height: 28px; padding: 8px 12px; font-size: 12px;" >
                            <b>Livre</b>
                        </span>
                        
                        <span class="badge badge-fill badge-small color-gray" style="margin-right: 5px; float: right; height: 28px; padding: 8px 12px; font-size: 12px;" >
                            <b>Ocupado</b>
                        </span>
                        
                        <span class="badge badge-fill badge-small color-red" style="margin-right: 5px; float: right; height: 28px; padding: 8px 12px; font-size: 12px;" >
                            <b>Bloqueado</b>
                        </span>
                    </h6>
                    
                    
                    <hr style="opacity: 0.3; margin-bottom: 15px; margin-top: 15px;">
                </div>    

                <div v-for="(item, index) in horarios.itens" v-if="item.itens[0]">
                    <div class="container mb-5" v-if="item.itens[0].horarios.length > 0">
                        <small style="display: block; margin-bottom: 5px">
                            {{item.extenso}}
                        </small>   
                        <div v-for="(item2, index2) in item.itens[0].horarios" class="" style="width: auto; display: inline-block; margin-right: 5px; margin-bottom: 5px">
                            <span v-on:click="editar(item2, item)" class="badge badge-fill badge-large" v-bind:class="{'color-green': !item2.pedidoCod, 'color-gray': item2.pedidoCod, 'color-red': item2.bloqueado}" style="border: none !important;">
                                <b>{{item2.horaFormatada}}</b>
                            </span>
                        </div>    
                         
                    </div>                                                   
                </div>  

<!--                 <div v-for="(item, index) in horarios.itens" v-if="item.itens[0]">
                    <div class="container mb-5" v-if="item.itens[0].horarios.length > 0">
                        <small>
                            <b>
                                {{item.extenso}}
                            </b>
                        </small>
                    </div>
                    <div v-if="item.itens.length > 0" data-space-between="10" data-slides-per-view="auto" data-centered-slides="false" class="swiper-container swiper-init horarios-swiper mb-10" style=" padding-right: 15px; padding-left: 15px;">
                        <div class="swiper-wrapper" style="">
                            <div v-for="(item2, index2) in item.itens[0].horarios" class="swiper-slide" style="width: auto;">
                                <span v-on:click="editar(item2, item)" class="badge badge-outline badge-large" v-bind:class="{'color-green': !item2.pedidoCod, 'color-gray': item2.pedidoCod, 'color-red': item2.bloqueado}">
                                    <b>{{item2.horaFormatada}}</b>
                                </span>
                            </div>
                        </div>
                    </div>                                                  
                </div>     -->                                               
            </div>                                                   
        </div>
        
        <!-- <Toolbar></Toolbar> -->
    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
export default {
    name: 'VisualizarHorarios',
    components: {
        'Top': Top,
        'Toolbar': Toolbar
    },          
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }
            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + (time ? (" " + time) : "");
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },      
    data () {
        var self                    = this;
        return {
            "voltar":               false,
            "horarios": {
                "itens":           [],
                "loaded":           false
            },
            "agendas": {
                "itens":           [],
                "loaded":           false
            }, 
            "catalogo": {
                "itens":           [],
                "loaded":           false
            },                        
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "quantidade":       1,
                "agendaTipo":       ""
            },
            "swiperOptions": {
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },                
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                },            
                "speed":            500,
                // "freeModeMomentum":     true,
                // "slidesPerView":        "auto",
                // "freeMode":             true,
            },            
            "agenda":   null    
        }
    },
    computed :{
        consultas : function(){
            var self    = this;
            var itens   = [];

            self.itens = self.catalogo.itens.filter(function(item) {
                if (item.metodo == "consulta") {
                    itens.push(item);
                }
            });

            return itens;
        }
    },    
    methods: {      
        setAgendaTipo: function(tipo) {
            var self = this;
            console.log("setAgendaTipo()", tipo);
            self.form.agendaCod     = "";
            self.horarios.itens     = [];
            self.agenda             = null;
            self.horarios.loaded    = false;
            self.form.agendaTipo    = tipo;
            self.$forceUpdate();
            self.init();
        },
        setAgenda: function(obj) {
            var self = this;
            console.log("setAgenda()", obj);

            self.form.agendaCod = obj.cod;
            self.agenda = obj;
            self.$forceUpdate();
            self.init();
        },
        setCatalogo: function(item) {
            var self = this;
            console.log("setCatalogo()", item);

            self.form.catalogoCod   = item.cod;
            // self.form.valor         = item.valor;
            self.$forceUpdate();
            loading.show();
            self.get().finally(function() {
                loading.hide();
            });
        },
        editar: function(item, item2) {
            var self            = this;
            console.log("editar()", item);

            // console.log("addItem()");

            if (item.pedidoCod) {
                self.$root.go("DetalhesPedidos", JSON.stringify({"c": item.pedidoCod}));
            } else if (!item.bloqueado) {
                
                var self                = this;
                confirm("Você tem certeza que deseja bloquear?", function() {
                 
                    var form = {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "status":       "bloquear",
                        "data":         item2.data,
                        "horaInicio":   item.horaInicio,
                        "horaFinal":    item.horaFinal,
                    };                

                    loading.show();
                    
                    axios.put("api/horario-de-atendimento.php", form)
                    .then(response => {
                        console.log("editar() response", response)
                        self.getHorarios()
                        .finally(function() {
                            loading.hide();
                        });
                    })
                    .catch(error => {
                        console.log("editar() error", error)
                        loading.hide();
                        alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    });
                });                
            } else {
                confirm("Você tem certeza que deseja desbloquear?", function() {

                    var form = {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "status":       "desbloquear",
                        "data":         item2.data,
                        "horaInicio":   item.horaInicio,
                        "horaFinal":    item.horaFinal,
                    };                

                    loading.show();
                    
                    axios.put("api/horario-de-atendimento.php", form)
                    .then(response => {
                        console.log("editar() response", response)
                        self.getHorarios()
                        .finally(function() {
                            loading.hide();
                        });
                    })
                    .catch(error => {
                        console.log("editar() error", error)
                        loading.hide();
                        alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    });
                });  
            }
        },               
        getAgendas: function() {
            var self        = this;
            console.log("getAgendas()");
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod,
                        "tipo":         "agendas"
                    }
                };

                axios.get("api/prestadores-v2.php", form)
                .then(response => {
                    
                    console.log("getAgendas() response", response);
                    self.agendas        = response.data.result;
                    
                    self.$forceUpdate();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));                 
                });   
            });   
        },
        getHorarios: function() {
            var self        = this;
            console.log("getHorarios()");
            loading.show();
            return new Promise(function(resolve, reject) {

                self.horarios.itens     = [];
                self.horarios.loaded    = false;
                self.$forceUpdate();

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod,
                        "tipo":         "horarios",
                        "agenda":       true,
                        "agendaCod":    self.form.agendaCod,
                        "agendaTipo":   self.form.agendaTipo
                    }
                };

                axios.get("api/prestadores-v2.php", form)
                .then(response => {
                    
                    console.log("getHorarios() response", response);
                    self.horarios           = response.data.result;
                    // self.detalhes.descricao = response.data.result.descricao.replaceAll('\\n','\n');

                    self.$forceUpdate();
                    setTimeout(function() {
                        var swiper = new Swiper('.horarios-swiper', $(".horarios-swiper").data());
                    }, 200);

                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getHorarios() error", error);                    
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));                   
                });   
            });   
        },
        init: function() {
            var self = this;
            console.log("init()");

            self.form.catalogoCod = "";
            self.$forceUpdate();

            Promise.resolve()
            .then(self.getAgendas)
            .then(self.getHorarios)
            .finally(function() {

                console.log("Buscou tudo")
        
                self.$forceUpdate();
                self.$root.$forceUpdate();
                setTimeout(function() {
                    loading.hide();
                    // setTimeout(function() {
                    //     self.$root.$forceUpdate();
                    //     self.$forceUpdate();
                    // }, 1000);

                }, 1000);
        

            });            
        }            
    },    
    activated: function() {
        var self = this;
        console.log("activated", self);

        // if (!self.$route.query.c) {
        //     self.$root.back();
        //     return false;
        // }
        self.form.cod   = self.$root.user.cod;
        if (self.$route.query.tipo) {
            self.form.agendaTipo = self.$route.query.tipo;
        }       

        self.init();

    },    
    mounted: function() {
        loading.hide();
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">
   
    .tag-list {
        margin-bottom: 0px !important;
        margin-top: 0px;
    }

    .item-title {
        margin-bottom: 0px !important;
        line-height: 130%;
        font-weight: 500;
        font-size: 16px;
    }
    .chip-label {
        font-weight: bold;
        font-size: 12px !important;
    }
    .chip {
        line-height: 18px !important;
        height: auto !important;
        min-height: 18px !important;
        /*padding-bottom: 0px;*/
        /*padding-top: 0px;*/
        margin-top: -4px;
        margin-left: -2px;
        margin-bottom: 5px;
    }
    .dz-media {
        margin-bottom: 5px !important;
    }
    .tabbar.tab-style-2 .tab-link:after {
        display: none !important;
    }

    .banner {
        background: var(--f7-theme-color);
        padding: 20px;
        margin-bottom: 30px;
    }

    .banner h4 {
        color: #fff;
        line-height: 130%;
        padding: 0px !important;
        margin: 0px !important;
    }

    .banner p {
        color: #fff;
        line-height: 130%;
        padding: 0px !important;
        margin: 0px !important;
    }    

    .img-perfil {
        width: 50px;
        height: 50px;
        background-size: cover;
        background-position: center;
        border: 1px solid #ddd;
        border-radius: 6px;
        display: inline-block;
    }    

    .col-50-grid {
      margin: 0;
      display: grid;
      grid-template-rows: 1fr auto;
      margin-bottom: 10px;
      break-inside: avoid;    
    }

    .row-grid {
      column-count: 2;
      column-gap: 20px;
    }
  
    .item-bx.item-grid {
        margin-bottom: 15px;
    }         

    .categories-bx.active {
        background: #f8b832 !important;
        color: #222 !important;
    }

    .cart-list-area {
        padding-left: 0;
        padding-right: 0;
    }

    .cart-list {
        overflow: hidden;
        margin: 0;
    }

    .cart-item {
        background-color: #fff;
        overflow: unset;
        margin: 6px 0;
        border-bottom: 1px solid #ddd;
        padding-bottom: 0px;        
    }        
   
    .cart-item .item-inner {
        background-color: #fff;
        padding: 12px 30px;
    }   

    .cart-item .item-media {
        min-width: 95px !important;
        width: 95px;
        position: relative;
        padding: 0;
        border-radius: 16px;
        overflow: hidden;
        margin-right: 20px;
        height: 115px;
        align-items: flex-start;
        height: 105px;
    }

    .cart-item .item-media img {
        width: 100%;
    }

    .cart-item .item-media .item-price {
        background-color: var(--f7-theme-color);
        color: #fff;
        position: absolute;
        bottom: 0;
        margin: 0;
        width: 100%;
        left: 0;
        text-align: center;
        font-weight: 500;
        font-size: 16px;
        padding: 5px;
        border-radius: 16px;
        box-sizing: border-box;
    }

    .cart-item .item-info {
        width: 100%;
        justify-content: space-between;
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 5px 0;
        box-sizing: border-box;
    }

    .cart-item .item-foot {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .cart-item .item-foot .item-total {
        margin: 0;
        font-weight: 500;
        font-size: 16px;
    }                        

    .cart-item .item-content {
        padding-left: 0;
        transition: all 0.5s;
    }

    .cart-item .item-head .category {
        margin: 0;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.6);
    }

    .cart-item .item-title a {
        color: #000;
        word-break: break-word;
        white-space: break-spaces;
        text-overflow: ellipsis;
        display: block;
        line-height: 130%;
    }

    .cart-item .item-title {
        font-weight: 500;
        margin: 0 0 10px;
    }        

    .cart-item .item-media div {
        width: 100%;
        height: 100%;
        background-size: cover !important;
        background-position: center;
        background: #efefef;
        border-radius: 6px;
    }

    .button-round {
        border-radius: 20px !important;
    }

    .badge-large {
        padding: 14px 11px;
    }

    .badge-outline.badge-default {
        background: transparent !important;
        border: 2px solid var(--f7-theme-color-shade) !important;
        color: var(--f7-theme-color-shade);
    }

    .badge.color-secondary {
        border: 2px solid var(--f7-theme-color-shade) !important;
    }

    .badge.color-primary {
        border: 2px solid var(--f7-theme-color) !important;
    }    

    .badge.color-green:not(.badge-outline) {
        border: 2px solid #4cd964 !important;
    }

    .badge-outline.small {
        /*background: transparent !important;*/
        /*border: 2px solid #4cd964 !important;*/
        /*color: #555;*/
        font-size: 14px;
    }    

    .container {
        padding-left: 15px !important;
        padding-right: 15px !important;
    }

    .button-fill.color-grey {
        background: #ddd !important;
        color: #666 !important;
    }

    .badge-large.color-primary {
        background: var(--f7-theme-color) !important;
        border: 2px solid var(--f7-theme-color) !important;
    }

    .badge-outline.color-grey {
        background: transparent !important;
        border: 2px solid #bbb !important;        
        color: #bbb !important;        
    }
</style>



// WEBPACK FOOTER //
// src/components/VisualizarHorarios.vue